<template>
  <div class="container mt-4">
      <Loading v-if="!fixture"/>
      <div v-else>
        <div class="row mb-2">
          <div class="col-10">
            <h3 class="mb-4">{{ fixture.name }}<small class="ml-3 text-muted">Fixture</small></h3>
          </div>
          <div class="col-2 text-right">
            <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item" v-if="fixture.event">Event: <router-link :to="{ name: 'Event', params: { id: fixture.event._id }}">{{ fixture.event.name }}, {{ fixture.event.competition.name }}</router-link></li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row" v-if="home && home.team && away && away.team">
          <div class="col-4">
            <div class="card p-3">
              <h4>{{home.team.name}}</h4>
              <router-link :to="{ name: 'TeamShow', params: { id: home.team._id }}"><button class="btn btn-primary btn-sm mt-4">More...</button></router-link>
            </div>
          </div>
          <div class="col-4">
            <div class="card p-3">
              <h4>{{away.team.name}}</h4>
              <router-link :to="{ name: 'TeamShow', params: { id: away.team._id }}"><button class="btn btn-primary btn-sm mt-4">More...</button></router-link>
            </div>
          </div>
          <div class="col-4">
            <div class="card p-3">
              <h6>Fixture details</h6>
              <div class="row mb-1">
                <div class="col-4"><b>Date</b></div>
                <div class="col-8"><span>{{fixture.date_start | moment("DD/MM/YY HH:mm")}}</span></div>
              </div>
              <div class="row">
                <div class="col-4"><b>Venue</b></div>
                <div class="col-8"><span v-if="fixture.venue">{{fixture.venue.name | moment("DD/MM/YY HH:mm")}}</span><span class="text-muted" v-else>Venue not set</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr class="mt-5">
            <router-link :to="{ name: 'FixtureEdit', params: { id: fixture._id }}"><button class="btn btn-warning mr-2">Edit</button></router-link>
            <button class="btn btn-danger" v-b-modal.delete-fixture-modal>Delete</button>
          </div>
        </div>
        <b-modal id="delete-fixture-modal" title="Warning: Fixture Deletion" :no-fade="true" @ok="deleteFixture">
          <div>
            <p>
              Proceed with <b>extreme</b> caution.
              <br>
              This will delete the fixture.
            </p>
          </div>
        </b-modal>
      </div>
  </div>
</template>
<script>
import { fixtureService } from '../../services/fixture'
import { fixtureTeamService } from '../../services/fixtureteam'
export default {
  name: 'Fixture',
  data () {
    return {
      fixture: null
    }
  },
  computed: {
    home () {
      if (this.fixture) {
        return this.fixture.fixtureteams.filter(ft => {
          if (ft.side === 'Home') {
            return true
          } else {
            return false
          }
        })[0]
      } else {
        return null
      }
    },
    away () {
      if (this.fixture) {
        return this.fixture.fixtureteams.filter(ft => {
          if (ft.side === 'Away') {
            return true
          } else {
            return false
          }
        })[0]
      } else {
        return null
      }
    }
  },
  mounted () {
    fixtureService.getOne(this.$route.params.id).then(result => {
      this.fixture = result.data.fixture
    })
  },
  methods: {
    deleteFixture () {
      fixtureService.deleteOne(this.fixture._id).then(resFixtures => {
        fixtureTeamService.deleteMany(this.fixture.fixtureteams.map(ft => ft._id)).then(resFixtureTeams => {
          if (this.fixture.event) {
            this.$router.push({ name: 'Event', params: { id: this.fixture.event._id } })
          } else {
            this.$router.push({ name: 'Calendar' })
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Fixtures/Fixture.vue